import React, { useState } from 'react';
import { personInitials, personName } from '../utils/person';

const PersonAvatar = ({ person, size = 'md', className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const initials = personInitials(person);
  const alt = personName(person);
  const showImage = person?.profile_image_url && !imgFailed;

  return (
    <span className={`person-avatar person-avatar--${size} ${className}`.trim()}>
      {showImage ? (
        <img
          src={person.profile_image_url}
          alt={alt}
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span className="person-avatar-initials" aria-hidden>
          {initials}
        </span>
      )}
    </span>
  );
};

export default PersonAvatar;
